// extracted by mini-css-extract-plugin
export default {"searchContainer":"GlobalSearch_searchContainer__F4qYO"};